import { SERVICES } from "@/lib/constants";
import { Plus } from "lucide-react";

export const Capabilities = () => {
    return (
        <section
            id="capabilities"
            data-testid="capabilities-section"
            className="relative bg-sand py-24 md:py-32 border-t border-line"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14 md:mb-20">
                    <div className="reveal max-w-2xl">
                        <div className="text-xs uppercase tracking-[0.25em] font-bold text-terracotta mb-5">
                            <span className="inline-block w-8 h-px bg-terracotta align-middle mr-3" />
                            Capabilities
                        </div>
                        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tighter font-medium text-ink leading-[1.02]">
                            Four scopes. <br />
                            One trusted subcontractor.
                        </h2>
                    </div>
                    <p className="reveal text-base md:text-lg text-stone max-w-sm leading-relaxed">
                        Waterwise is our specialty — but we install traditional sod, vinyl fencing,
                        retaining walls, and full hardscape too. Each scope runs with its own foreman
                        and crew, coordinated by one PM assigned to your job.
                    </p>
                </div>

                {/* Bento layout */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                    {SERVICES.map((s, idx) => {
                        // turf=feature large, others variable
                        const spans = [
                            "md:col-span-7 md:row-span-2",  // turf - feature
                            "md:col-span-5",                 // xeriscape
                            "md:col-span-5",                 // walls
                            "md:col-span-7",                 // fencing
                        ];
                        const heights = ["h-[520px] md:h-full", "h-80", "h-80", "h-[420px]"];
                        return (
                            <article
                                key={s.id}
                                data-testid={`capability-card-${s.id}`}
                                className={`reveal group relative overflow-hidden border border-line bg-ink ${spans[idx]} ${heights[idx]}`}
                                style={{ transitionDelay: `${idx * 80}ms` }}
                            >
                                <img
                                    src={s.image}
                                    alt={s.title}
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink/95 via-ink/45 to-ink/10" />
                                <div className="relative z-10 h-full flex flex-col justify-between p-7 md:p-9">
                                    <div className="flex items-center justify-between">
                                        <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-bone/80">
                                            0{idx + 1}
                                        </span>
                                        <Plus size={18} className="text-bone/60 group-hover:text-terracotta group-hover:rotate-90 transition-all duration-500" />
                                    </div>
                                    <div>
                                        <h3 className="font-heading text-3xl md:text-4xl tracking-tight font-medium text-bone leading-tight">
                                            {s.title}
                                        </h3>
                                        <p className="mt-3 max-w-md text-sm md:text-base text-bone/85 leading-relaxed">
                                            {s.blurb}
                                        </p>
                                        <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-2">
                                            {s.bullets.map((b) => (
                                                <li key={b} className="text-[11px] uppercase tracking-[0.18em] font-semibold text-terracotta flex items-center gap-2">
                                                    <span className="w-1 h-1 bg-terracotta block" />
                                                    {b}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
